
























import Vue from 'vue'
import SimpleModalFooterButton from '@/components/modal/basics//SimpleModal/SimpleModalFooterButton.vue'

export default Vue.extend({
  components: {
    SimpleModalFooterButton,
  },
  props: {
    isAlert: {
      type: Boolean,
      default: false,
    },
  },
})
